import React from 'react'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert from '@mui/material/Alert'

const SimpleSnackbar = (props) => {
    const { message, clearMessage, type } = props
    const [open, setOpen] = React.useState(true)

    const handleClose = () => {
        setOpen(false)
        clearMessage()
    }

    return (
        <Snackbar
            open={open}
            autoHideDuration={800000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            <MuiAlert
                onClose={handleClose}
                severity={type}
                elevation={6}
                variant="filled"
            >
                {message}
            </MuiAlert>
        </Snackbar>
    )
}

export default SimpleSnackbar
